import { render } from "./SliderView.vue?vue&type=template&id=cf0e03a4"
import script from "./SliderView.vue?vue&type=script&lang=js"
export * from "./SliderView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__